import { NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { NgxLoadingModule, ngxLoadingAnimationTypes } from 'ngx-loading';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { FooterComponent } from './footer/footer.component';
import { SearchComponent } from './search/search.component';
import { ResendComponent } from './search/resend/resend.component';
import { SentHistoryComponent } from './search/sent-history/sent-history.component';
import { DocumentComponent } from './document/document.component';
import { OtpComponent } from './otp/otp.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { HeaderComponent } from './header/header.component';
import { DocumentListComponent } from './document-list/document-list.component';

import { MultiTranslateHttpLoaderService } from './core/service/multi-translate-http-loader.service';
import { FooterAzayLogoComponent } from './footer-azay-logo/footer-azay-logo.component';
import { PostMessageModule } from './postmessage';
import { DatePipe } from '@angular/common';

export const httpLoaderFactory = (httpClient: HttpClient): MultiTranslateHttpLoaderService =>
  new MultiTranslateHttpLoaderService(httpClient);

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    SearchComponent,
    ResendComponent,
    SentHistoryComponent,
    DocumentComponent,
    OtpComponent,
    ErrorMessageComponent,
    HeaderComponent,
    DocumentListComponent,
    FooterAzayLogoComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    PostMessageModule,
    SharedModule,
    ModalModule.forRoot(),
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgxLoadingModule.forRoot({
      animationType: ngxLoadingAnimationTypes.circle,
      fullScreenBackdrop: true,
      backdropBackgroundColour: 'rgba(0,0,0,0.1)',
      backdropBorderRadius: '3px',
      primaryColour: '#003781',
      secondaryColour: '#007ab3',
      tertiaryColour: '#ffffff'
    }),
    NgxPermissionsModule.forRoot(),
    NgxExtendedPdfViewerModule
  ],
  providers: [BsModalRef, DatePipe],
  bootstrap: [AppComponent]
})
export class AppModule {}
